// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_d7-3";
export var flatBottomCorners = "_d7-5";
export var productImage = "_d7-0";
export var quantityContainer = "_d7-2";
export var quantityHeader = "_d7-6";
export var tooltip = "_d7-1";
export var wrapAndEllipsesOverflow = "_d7-4";